
(function appModuleDefinition() {

    angular.module('App', [
        'EDRConfig', 'Config', 'ngAnimate', 'pascalprecht.translate', 'ui.router', 'AuthExtend', 'oc.lazyLoad', 'Messages', 'Errors', 'ErrorsExtend', 'xeditable',
        'Loading', 'Language', 'NavMenu', 'Inicio', 'ui.Header', 'ui', 'ui.Layout', 'Login', 'Dynamic', 'Alerts', 'PwdReset', 'Profile', 'ui.mask', 'UiSideNav', 'UiSearchBar',
        'PasswordStrength', 'ConfigMenu', 'Entities', 'LoginPage', 'RESTUrlBuilder', 'ui.bootstrap.datepicker', 'ngSanitize', 'DocumentType', 'DatePickerCalendar', 'Favorites',
        'Role', 'Metadata', 'User', 'Audit', 'OrganizationalUnit', 'Document', 'File', 'ContainerType', 'DocumentContainer', 'ImportProcess', 'Calendar', 'NotificationConfig', 'AuthNotificationConfig', 'Workflow', 'NotificationPopup', 'Status',
        'BackgroundTask', 'ImportImagesProcess', 'Migrator', 'Importer', 'DisableInputsAutocomplete', 'NonBubblingClick', 'SystemTranslateFilter', 'PDFViewer', 'TwainCapture', 'UserQuery', 'SecurityData', 'PDFViewerIe', 'TermsAndConditionsControl', 'Dba', 'ReplaceFile', 'LoginBrowserControl', 'HomeGrid'])
        .config([
            '$urlRouterProvider', 'alertsProvider', 'configProvider', 'loginProvider', 'authProvider', '$ocLazyLoadProvider', 'languageProvider',
            'uibDatepickerPopupConfig', 'dynamicProvider', 'uiProvider', 'twainCaptureProvider',
            function ($urlRouterProvider, alertsProvider, config, loginCfg, authProvider, $ocLazyLoadProvider, languageProvider,
                datepickerPopupConfig, dynamicProvider, uiProvider, twainCaptureProvider) {
                /*
                 * Traductor para el configurador twain.
                 */
                twainCaptureProvider.configLabelsTranslator(['$translate', '$labels', function ($translate, $labels) {

                    if (typeof ($labels) === 'string') {
                        return $translate.instant('Twain_' + $labels);
                    }

                    angular.forEach($labels, function (value, key) {
                        $labels[key] = $translate.instant('Twain_' + key);
                    })

                    return $labels;
                }]);

                if (config.languageUrl())
                    languageProvider.setLanguageUrl(config.languageUrl());
                if (config.localeUrl())
                    languageProvider.setLocaleUrl(config.localeUrl());

                languageProvider.onLanguageChanged([
                    '$translate', function languageChanged($translate) {

                        $translate(['Today', 'Close', 'Clear']).then(function (translated) {
                            datepickerPopupConfig.currentText = translated.Today;
                            datepickerPopupConfig.clearText = translated.Clear;
                            datepickerPopupConfig.closeText = translated.Close;
                        });
                    }
                ]);

                languageProvider.preferredLanguage('es');
                languageProvider.fallbackLanguage('es');
                languageProvider.use('es');

                authProvider.setClientId(window.clientId);
                authProvider.setOrganizationId(window.organizationId);
                authProvider.setAuthApiName('auth');

                loginCfg.setChangePasswordCallbackUrl(config.appUrl('/Home/Index#/pwd-reset/?code={0}'))
                    .setRegisterState('register')
                    .setConfirmMailState('confirm-mail')
                    .setLoggedState('inicio')
                    .setLoginState('login');

                // si no matchea una ruta, entonces configuro dynamic para que 
                // al cargar intente redireccionar si el usuario estaba cacheado.
                $urlRouterProvider.otherwise(function ($injector, $location) {

                    dynamicProvider.setRedirectUrl($location.url());
                    return '/';
                });

                $ocLazyLoadProvider.config({
                    loadedModules: ['App']
                });

                uiProvider.theming(true);
                uiProvider.rememberTheme(false); // por defecto es true
            }
        ])
        .run([
            'editableOptions', 'editableThemes', function (editableOptions, editableThemes) {
                editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
                editableThemes.bs3.errorTpl = ''; // saco el mensaje de error para que sea consistente con los formularios.
            }
        ])        
        .run([
            '$location', '$window', 'config', function ($location, $window, config) {       
                if (config.custom('googleAnalticsKey')) {
                    $window.ga('create', config.custom('googleAnalticsKey'), 'auto');
                }
        }])        
        .run(['$rootScope', '$state', function ($rootScope, $state) {
            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                $state.previous = { state: fromState.name, params: fromParams }
            });

            $state.goBack = function (defaultState, defaultParams) {
                // No vuelvo a pantallas que no siempre pueda volver.
                if (this.previous && this.previous.state && this.previous.state !== '' && this.previous.state !== 'mydocument-detail' && this.previous.state !== 'document-modify' && this.previous.state !== 'document-container-modify' && this.previous.state !== 'document-version-all') {
                    this.go(this.previous.state, this.previous.params);
                } else {
                    if (defaultState) {
                        this.go(defaultState, defaultParams);
                    }
                }
            };
 
            $state.hasPrevious = function () {
                if (this.previous && this.previous.state && this.previous.state !== '') {
                    return true;
                } else {
                    return false;
                }
            }
        }]);
})();
